
import React, { useState, useEffect, useRef } from "react";
import "../../style/UserCreateForm.css";
import Loading from "../../components/loading.jsx";
import Sidebar from "../../components/sidebar.jsx";
import { BASE_URL, Renko_Data_API } from "../../utils/config.js";
import { Button } from 'primereact/button';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Modal, Alert } from "react-bootstrap";
import Switch from "@mui/material/Switch";
import RefreshIcon from '@mui/icons-material/Refresh';
import ViewRenkoChart from '../../components/Charts/viewRenkoChart.js'
import { styled } from "@mui/material/styles";
import { renko } from "react-stockcharts/lib/indicator";

const AutomateReknko = () => {


	const ALLRenkoData = JSON.parse(localStorage.getItem("ALLRenkoData"));
	console.log("ALL RENKO DATA",ALLRenkoData)
	const AutomateSymbol = localStorage.getItem("AutomateSymbol");

	const [Symbols, setSymbols] = useState(AutomateSymbol ? AutomateSymbol : "NIFTY");
	const [SensexSymbols, setSensexSymbols] = useState("SENSEX");

	const [RenkoIntervalDecission, setRenkoIntervalDecission] = useState([{
		"prv_prv_interval": "",
		"prv_interval": "",
		"present_interval": ""
	}]);

	const [AllRenko, setAllRenko] = useState(ALLRenkoData ? ALLRenkoData.filter((item) => item.name === Symbols) : [{
		"interval": '375',
		"brick_size": '100',
		"buy_sell_box": "2",
		"ExitBox": 0,
		"range_mode": 0,
	}]);
	const [SensexRenko, setSensexRenko] = useState(ALLRenkoData ? ALLRenkoData.filter((item) => item.name === SensexSymbols) : [{
		"interval": '375',
		"brick_size": '100',
		"buy_sell_box": "2",
		"ExitBox": 0,
		"range_mode": 0,
	}]);
	console.log("ALLRENKO", AllRenko);
	console.log("SENSEX RENKO", SensexRenko);
	const [data, setData] = useState([]);
	const [RenkoInterval, setRenkoInterval] = useState(ALLRenkoData ? AllRenko[0].interval : '375');
	const [BrickSize, setBrickSize] = useState(ALLRenkoData
		? AllRenko[0].range_mode === "atr" ? AllRenko[0].atr_brick ? AllRenko[0].atr_brick : 30 : AllRenko[0].brick_size
		: '100');

	const [BuySellBox, setBuySellBox] = useState(ALLRenkoData ? AllRenko[0].buy_sell_box : '2');
	const [ExitBox, setExitBox] = useState(ALLRenkoData ? AllRenko[0].ExitBox : '0');
	const [telgramlive_local, setTelgramlive_local] = useState(ALLRenkoData ? AllRenko[0]?.groups === 'LOCAL' ? false : true : false);
	const [Sensex_telgramlive_local, setSensexTelgramlive_local] = useState(ALLRenkoData ? SensexRenko[0]?.groups === 'OFFS' ? false : true : false);
	const [sendOption, setSendoption] = useState(ALLRenkoData ? AllRenko[0]?.SendOption:false);
	const [range_mode, setrange_mode] = useState(ALLRenkoData ? AllRenko[0].range_mode : "fixed");
	const [atrData, setatrData] = useState(ALLRenkoData ? AllRenko[0].atr === null ? 0 : AllRenko[0].atr : 0);

	const [showatrDialog, setshowatrDialog] = useState(false);


	const [loader, setLoader] = useState(false);
	const [sourcePath, setsourcePath] = useState("close");
	const [showDialog, setshowDialog] = useState(false);
	const [Remarks, setRemarks] = useState("");
	const [RenkoDialogData, setRenkoDialogData] = useState({
		Symbols: Symbols,
		RenkoInterval: RenkoInterval,
		BrickSize: BrickSize,
		range_mode: range_mode,
		BuySellBox: BuySellBox,
		ExitBox: ExitBox,
		groups: telgramlive_local
	});
	const [Telegram, setTelegram] = useState(false);
	const [SensexTelegram, setSensexTelegram] = useState(false);
	const [SOption, setSOption] = useState(false);
	const [TelegramAlert, SetTelegramAlert] = useState(false);
	const [SensexTelegramAlert, SetSensexTelegramAlert] = useState(false);
	const [sendOptionAlert, SetSendOptionAlert] = useState(false);
	const [lastupdatedtime, setlastupdatedtime] = useState("");

	const [Errormessage, setErrormessage] = useState("");
	const [showSuccessMessage, setshowSuccessMessage] = useState(false);
	const [rotation, setRotation] = useState(0);

	const [lastbrick, setlastbrick] = useState({});
    const [errorDialog,setErrorDialog]=useState(false);
    const [errorMessage,setErrorMessage]=useState("");

	const SymbolsRef = useRef(Symbols);
	const BrickSizeRef = useRef(BrickSize);
	const RenkoIntervalRef = useRef(RenkoInterval);
	const range_modeRef = useRef(range_mode);
	const BuySellBoxRef = useRef(BuySellBox);
	const ExitBoxRef = useRef(ExitBox);



	useEffect(() => {
		setLoader(true);

		handleIntervalDecission();
		fetchShowAll();
		fetchRenkoData();

		const intervalId = setInterval(() => {
			fetchRenkoData();
			fetchShowAll();
			handleIntervalDecission();
		}, 30000);

		return () => clearInterval(intervalId); // Cleanup function
	}, []);



	// Function to fetch Renko data
   const fetchRenkoData = async () => {
	try {
		const url = `${Renko_Data_API}get_5min_data?symbol=${SymbolsRef.current}
			&Brick_size=${BrickSizeRef.current}
			&interval=${RenkoIntervalRef.current}
			&Signal_box=${BuySellBoxRef.current}
			&ExitBrick=${ExitBoxRef.current}`.replace(/\s+/g, ''); // Remove whitespace

		console.log("Fetching Renko data from URL:", url);

		const response = await fetch(url, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		});

		if (!response.ok) {
			throw new Error(`Error : ${response.statusText}`);
		}

		const text = await response.text();

		if (!text || text.trim().length === 0) {
			throw new Error("API returned empty response");
		}

		// Fix NaN values by replacing them with null before parsing JSON
		const fixedJson = text.replace(/\bNaN\b/g, "null");

		let data;
		try {
			data = JSON.parse(fixedJson);
		} catch (jsonErr) {
			console.error("Failed to parse JSON:", jsonErr);
			throw new Error("Invalid JSON format in API response");
		}

		if (!Array.isArray(data) || data.length < 2) {
			throw new Error("API returned insufficient or malformed data");
		}

		const parsedData = data.slice(1).map((row) => ({
			date: new Date(row.datetime),
			open: row.ROpen,
			high: row.RHigh,
			low: row.RLow,
			close: row.Rclose,
			RDecision_final: row.RDecision_final
		}));

		const renkoCalculator = renko().options({
			reversalType: range_mode,
			fixedBrickSize: parseFloat(BrickSize >= 1 ? (BrickSize < 500 ? BrickSize : 100) : 1),
			sourcePath: sourcePath,
		});

		const calculatedData = renkoCalculator(parsedData).map((d, index) => ({
			...d,
			RDecision_final: parsedData[index]?.RDecision_final || "UNKNOWN",
		}));

		setlastbrick(calculatedData[calculatedData.length - 1]);
		setData(parsedData);
		setLoader(false);
	} catch (error) {
		console.error("Error fetching Renko data:", error.message || error);
		setErrorMessage(`Error: ${error.message}`);
		setErrorDialog(true)
		setTimeout(() => {
			setErrorDialog(false);
			setErrorMessage('')
		}, 2000);
		setLoader(false);

	}
   }; 


// this fucntion is used to update renko data

const UpdateRenkoData = async () => {
	try {
		setLoader(true);

		const loginuser = JSON.parse(localStorage.getItem("loginData"));
		if (!loginuser || !loginuser.token) {
			throw new Error("User not authenticated");
		}

		const body = {
			symbol: RenkoDialogData.Symbols,
			modifiedBy: loginuser.user_id,
			remark: Remarks,
			updates: {},
		};

		const updates = body.updates;

		if (RenkoDialogData.RenkoInterval !== RenkoInterval) updates.interval = RenkoDialogData.RenkoInterval;
		if (RenkoDialogData.BrickSize !== BrickSize) updates.brick_size = RenkoDialogData.BrickSize;
		if (RenkoDialogData.BuySellBox !== BuySellBox) updates.buy_sell_box = RenkoDialogData.BuySellBox;
		if (RenkoDialogData.ExitBox !== ExitBox) updates.ExitBox = RenkoDialogData.ExitBox;
		if (RenkoDialogData.range_mode !== range_mode) updates.range_mode = RenkoDialogData.range_mode;

		if (Object.keys(updates).length === 0) {
			setErrormessage("Please update at least one field");
			setshowSuccessMessage(true);
			setTimeout(() => {
				setshowSuccessMessage(false);
				setErrormessage("");
			}, 2000);
			setLoader(false);
			return;
		}

		console.log("Data sending for update:", body);

		const response = await fetch(`${BASE_URL}/renkoUpdateall`, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${loginuser.token}`
			},
			body: JSON.stringify(body)
		});

		if (!response.ok) {
			
			throw new Error(`API error ${response.status}: ${response.statusText}`);
		}

		const res = await response.json();

		if (res.status === 200 && res.data) {
			const allRenkoData = res.data;
			localStorage.setItem("ALLRenkoData", JSON.stringify(allRenkoData));

			const filterData = allRenkoData.filter((item) => item.name === Symbols);
			const filterData1 = allRenkoData.filter((item) => item.name === SensexSymbols);
			if (!filterData.length) throw new Error("Updated data not found for symbol");

			const item = filterData[0];
			const item1 = filterData1[0];
			setTelgramlive_local(item.groups !== "LOCAL");
			setSensexTelgramlive_local(item1.groups !=="LIVE")
			setSendoption(item.SendOption);
			setAllRenko(filterData);
			setSensexRenko(filterData1);

			setRenkoInterval(item.interval);
			setBuySellBox(item.buy_sell_box);
			setExitBox(item.ExitBox);
			setrange_mode(item.range_mode);

			if (item.range_mode === "atr") {
				setBrickSize(item.atr_brick || 30);
			} else {
				setBrickSize(item.brick_size);
			}

			setatrData(item.atr);

			setErrormessage("Data updated successfully");
		} else {
			throw new Error(res.message || "Unknown error from API");
		}

	} catch (error) {
		console.error("Error updating Renko data:", error.message || error);
		setErrormessage("Unable to update data. " + (error.message || ""));
	} finally {
		setshowSuccessMessage(true);
		setTimeout(() => {
			setshowSuccessMessage(false);
			setErrormessage("");
		}, 2000);
		setLoader(false);
	}
};


// this function is used to fetch renko data from api
	const fetchShowAll = async () => {
		try {
			let loginuser = JSON.parse(localStorage.getItem("loginData"));

			 await fetch(`${BASE_URL}/renkoShowAll`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${loginuser.token}`
				},
			}).then(response => response.json())
			.then(res => {
					const data = res
					console.log("response", data.data);
					if (res.status === 200) {
						console.log("value of symbol", SymbolsRef.current);

						setAllRenko(data.data.filter((item) => item.name === SymbolsRef.current));
						let filterData = data.data.filter((item) => item.name === SymbolsRef.current)
						let filterData1 = data.data.filter((item) => item.name === "SENSEX")
						let value = filterData[0]?.groups
						let value1 = filterData1[0]?.groups
						console.log("value", value);
						console.log("value1", value1);
						setTelgramlive_local(value)
						setSensexTelgramlive_local(value1)
						setAllRenko(filterData);
						setSensexRenko(filterData1);

						localStorage.setItem("ALLRenkoData", [JSON.stringify(data.data)]);
						console.log("data.data", filterData);
						console.log("data.data", filterData[0].brick_size);

						setRenkoInterval(filterData[0].interval);
						setBuySellBox(filterData[0].buy_sell_box);
						setExitBox(filterData[0].ExitBox);
						setrange_mode(filterData[0].range_mode);
						if (filterData[0].range_mode === "atr") {

							setBrickSize(filterData[0].atr_brick ? filterData[0].atr_brick : 30);

						}
						else {
							setBrickSize(filterData[0].brick_size);
							console.log("check BrickSize fetchShowAll", filterData[0].brick_size);
						}

						setatrData(filterData[0].atr);
						setLoader(false);


					} else {
						setErrorMessage(`Error: ${res.message}`)
						setErrorDialog(true)
						setLoader(false);
						setTimeout(() => {
							setErrorDialog(false)
							setErrorMessage(``)
						}, 2000);
					}
				}).catch((error)=>{
					setErrorMessage(`Error: ${error.message}`)
					setErrorDialog(true)
					setLoader(false);
					setTimeout(() => {
						setErrorDialog(false)
						setErrorMessage(``)
					}, 2000);
				})


		} catch (error) {

			console.log("error fetching get api", error);
			setLoader(false)
			setErrorMessage(`Error: ${error.message}`)
						setErrorDialog(true)
						setLoader(false);
						setTimeout(() => {
							setErrorDialog(false)
							setErrorMessage(``)
						}, 2000);
			

		}
	}

	const IOSSwitch = styled((props) => (
		<Switch
			focusVisibleClassName=".Mui-focusVisible"
			disableRipple
			{...props}
		/>
	))(({ theme }) => ({
		width: 42,
		height: 26,
		padding: 0,
		"& .MuiSwitch-switchBase": {
			padding: 0,
			margin: 2,
			transitionDuration: "300ms",
			"&.Mui-checked": {
				transform: "translateX(16px)",
				color: "#fff",
				"& + .MuiSwitch-track": {
					backgroundColor:
						theme.palette.mode === "dark" ? "#2ECA45" : "#23499E",
					opacity: 1,
					border: 0,
				},
				"&.Mui-disabled + .MuiSwitch-track": {
					opacity: 0.5,
				},
			},
			"&.Mui-focusVisible .MuiSwitch-thumb": {
				color: "#33cf4d",
				border: "6px solid #23499E",
			},
			"&.Mui-disabled .MuiSwitch-thumb": {
				color:
					theme.palette.mode === "light"
						? theme.palette.grey[100]
						: theme.palette.grey[600],
			},
			"&.Mui-disabled + .MuiSwitch-track": {
				opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
			},
		},
		"& .MuiSwitch-thumb": {
			boxSizing: "border-box",
			width: 22,
			height: 22,
		},
		"& .MuiSwitch-track": {
			borderRadius: 26 / 2,
			backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
			opacity: 1,
			transition: theme.transitions.create(["background-color"], {
				duration: 500,
			}),
		},
	}));



	const handleNumber = (e) => {
		const value = e.which ? e.which : e.keyCode;
		if (value < 48 || value > 58) {
			e.preventDefault();
		}

	}


	const handleValueChange = () => {
		console.log("RenkoDialogData", RenkoDialogData);
		setshowDialog(false);
		setLoader(true);
		setSymbols(RenkoDialogData.Symbols);
		setBrickSize(RenkoDialogData.BrickSize);

		setRenkoInterval(RenkoDialogData.RenkoInterval);
		setBuySellBox(RenkoDialogData.BuySellBox);
		setExitBox(RenkoDialogData.ExitBox);
		setrange_mode(RenkoDialogData.range_mode);


		SymbolsRef.current = RenkoDialogData.Symbols;
		BrickSizeRef.current = RenkoDialogData.BrickSize;
		RenkoIntervalRef.current = RenkoDialogData.RenkoInterval;
		range_modeRef.current = RenkoDialogData.range_mode;
		BuySellBoxRef.current = RenkoDialogData.BuySellBox;
		ExitBoxRef.current = RenkoDialogData.ExitBox;


		console.log("data", RenkoDialogData);
		const tempdata = ALLRenkoData.filter((item) => item.name === RenkoDialogData.Symbols);
		if (tempdata[0].interval !== RenkoDialogData.RenkoInterval || tempdata[0].buy_sell_box !== RenkoDialogData.BuySellBox || tempdata[0].ExitBox !== RenkoDialogData.ExitBox || tempdata[0].range_mode !== RenkoDialogData.range_mode || RenkoDialogData.range_mode === "atr" && tempdata[0].atr_brick !== RenkoDialogData.BrickSize || RenkoDialogData.range_mode === "fixed" && tempdata[0].brick_size !== RenkoDialogData.BrickSize) {

			
			console.log("Update the db", tempdata);
			UpdateRenkoData();
		

		}

		localStorage.setItem("AutomateSymbol", RenkoDialogData.Symbols)
		fetchShowAll();
		fetchRenkoData();
		handleIntervalDecission();
		setRemarks("");

	}


	const handleRemarks = (e) => {
		const value = e.target.value;
		if (value.length > 250) {
			e.preventDefault();
		}
		else {
			setRemarks(value);
		}
	}



	function formatDateTime(dateString) {
		const [datePart, timePart] = dateString.split('T'); // Split date and time
		const [year, month, day] = datePart.split('-'); // Extract date components
		const time = timePart.split('.')[0]; // Remove milliseconds

		return `${day}-${month}-${year} ${time}`;
	}


//  handle interval data change and fetch new price

	const handleIntervalDecission = async () => {
		try {
			const loginuser = JSON.parse(localStorage.getItem("loginData"));
	
			if (!loginuser || !loginuser.token) {
				throw new Error("User is not authenticated. Please login again.");
			}
	
			const response = await fetch(`${BASE_URL}/renkoIntervalData`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${loginuser.token}`
				},
			});
	
			if (!response.ok) {
				
				throw new Error(`API Error ${response.status}: ${response.statusText}`);
			}
	
			const Decission = await response.json();
	
			if (!Decission?.intervalData || !Array.isArray(Decission.intervalData)) {
				throw new Error("Unexpected response format from server.");
			}
	
			const filteredData = Decission.intervalData.filter(item => item.name === SymbolsRef.current);
	
			if (filteredData.length === 0) {
				console.warn("No matching data found for symbol:", SymbolsRef.current);
				setRenkoIntervalDecission([]);
				setlastupdatedtime("Not available");
				return;
			}
	
			console.log("handleIntervalDecission", filteredData);
	
			setRenkoIntervalDecission(filteredData);
			setlastupdatedtime(formatDateTime(filteredData[0]?.last_updated_time || new Date()));
	
		} catch (error) {
			console.error("Error fetching Interval decision data:", error.message || error);
			setRenkoIntervalDecission([]);
			setlastupdatedtime("Error loading time");
			
		}
	};
	




	// handle change color of brick 
	const handleDecissionColor = (value) => {
		switch (value) {
			case "HOLD":
				return "black";
			case "EXIT":
				return "#FFB200"; //yellow
			case "BUYYES":
				return "#5B913B"; //green
			case "SELLYES":
				return "red";
			default:
				return "#DA498D"; //purple
		}
	};


	// handle telegram local or live which is used for send signal in local or live group
	const handletelegramLiveLocalChange = async () => {
		setLoader(true)

		try {

			let loginuser = JSON.parse(localStorage.getItem("loginData"));
			console.log("telgram chekc ", Telegram);
			// let telegramValue = Telegram
			// if (Telegram) {
			// 	telegramValue = 'LIVE'
			// } else {
			// 	telegramValue = 'LOCAL'
			// }
			let body = JSON.stringify({
				symbol: RenkoDialogData.Symbols,
				target: 'groups',
				value: Telegram,
				modifiedBy: loginuser.user_id,
				Remark: ''
			})

			const response = await fetch(`${BASE_URL}/renkoUpdate`, {
				method: 'PUT',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${loginuser.token}`
				},
				body: body
			}).then(response => response.json())
				.then(res => {
					console.log(res);
					const data = res
					console.log("response", data.data);

					if (res.status === 200) {
						setTelgramlive_local(Telegram);
						setLoader(false);
						SetTelegramAlert(false);
						localStorage.setItem("ALLRenkoData", [JSON.stringify(data.data)]);
						setErrormessage("Data Updated successfully");
						setshowSuccessMessage(true);
						setTimeout(() => {

							setshowSuccessMessage(false);
							setErrormessage("");
						}, 2000);

					} else if (res.status === 500) {
						console.log("error fetching get api", res.message);
						setLoader(false)
						SetTelegramAlert(false);
						setErrormessage("Fail TO Update Telegram Value");
						setshowSuccessMessage(true);
						setTimeout(() => {

							setshowSuccessMessage(false);
							setErrormessage("");
						}, 2000);
					}
				}).catch((error) => {
					console.log("error fetching get api", error);
					setLoader(false)
					SetTelegramAlert(false);
					setErrormessage("Fail TO Update Telegram Value");
					setshowSuccessMessage(true);
					setTimeout(() => {

						setshowSuccessMessage(false);
						setErrormessage("");
					}, 2000);
				})



		} catch (error) {
			console.log("error fetching get api", error);
			setLoader(false)
			SetTelegramAlert(false);
			setErrormessage("Fail TO Update Telegram Value");
			setshowSuccessMessage(true);
			setTimeout(() => {

				setshowSuccessMessage(false);
				setErrormessage("");
			}, 2000);
		}







	};

	// handle telegram local or live which is used for send signal in local or live group
	const handleSensextelegramLiveLocalChange = async () => {
		setLoader(true)

		try {

			let loginuser = JSON.parse(localStorage.getItem("loginData"));
			console.log("Sensex telgram chekc ", SensexTelegram);
			
			let body = JSON.stringify({
				symbol: "SENSEX",
				target: 'groups',
				value: SensexTelegram,
				modifiedBy: loginuser.user_id,
				Remark: ''
			})

			const response = await fetch(`${BASE_URL}/renkoUpdate`, {
				method: 'PUT',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${loginuser.token}`
				},
				body: body
			}).then(response => response.json())
				.then(res => {
					console.log(res);
					const data = res
					console.log("response", data.data);

					if (res.status === 200) {
						setSensexTelgramlive_local(SensexTelegram);
						setLoader(false);
						SetSensexTelegramAlert(false);
						localStorage.setItem("ALLRenkoData", [JSON.stringify(data.data)]);
						setErrormessage("Data Updated successfully");
						setshowSuccessMessage(true);
						setTimeout(() => {

							setshowSuccessMessage(false);
							setErrormessage("");
						}, 2000);

					} else if (res.status === 500) {
						console.log("error fetching get api", res.message);
						setLoader(false)
						SetSensexTelegramAlert(false);
						setErrormessage("Fail TO Update Telegram Value");
						setshowSuccessMessage(true);
						setTimeout(() => {

							setshowSuccessMessage(false);
							setErrormessage("");
						}, 2000);
					}
				}).catch((error) => {
					console.log("error fetching get api", error);
					setLoader(false)
					SetSensexTelegramAlert(false);
					setErrormessage("Fail TO Update Telegram Value");
					setshowSuccessMessage(true);
					setTimeout(() => {

						setshowSuccessMessage(false);
						setErrormessage("");
					}, 2000);
				})



		} catch (error) {
			console.log("error fetching get api", error);
			setLoader(false)
			SetSensexTelegramAlert(false);
			setErrormessage("Fail TO Update Telegram Value");
			setshowSuccessMessage(true);
			setTimeout(() => {

				setshowSuccessMessage(false);
				setErrormessage("");
			}, 2000);
		}







	};

	// function to handle send option chnage to store in DB
	const handleSendOptionChange = async () => {
		setLoader(true)

		try {

			let loginuser = JSON.parse(localStorage.getItem("loginData"));
			console.log("telgram chekc ", SOption);
			let sendoption = ''
			if(SOption){
             sendoption = 1
			}else{
              sendoption = 0
			}
			let body = JSON.stringify({
				symbol: RenkoDialogData.Symbols,
				target: 'SendOption',
				value: sendoption,
				modifiedBy: loginuser.user_id,
				Remark: ''
			})

			const response = await fetch(`${BASE_URL}/renkoUpdate`, {
				method: 'PUT',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${loginuser.token}`
				},
				body: body
			}).then(response => response.json())
				.then(res => {
					console.log(res);
					const data = res
					console.log("response", data.data);

					if (res.status === 200) {
						setSendoption(SOption);
						setLoader(false);
						SetSendOptionAlert(false);
						localStorage.setItem("ALLRenkoData", [JSON.stringify(data.data)]);
						setErrormessage("Data Updated successfully");
						setshowSuccessMessage(true);
						setTimeout(() => {

							setshowSuccessMessage(false);
							setErrormessage("");
						}, 2000);

					} else if (res.status === 500) {
						console.log("error fetching get api", res.message);
						setLoader(false)
						SetSendOptionAlert(false);
						setErrormessage("Fail TO Update Send Option Value");
						setshowSuccessMessage(true);
						setTimeout(() => {

							setshowSuccessMessage(false);
							setErrormessage("");
						}, 2000);
					}
				}).catch((error) => {
					console.log("error fetching get api", error);
					setLoader(false)
					SetSendOptionAlert(false);
					setErrormessage("Fail TO Update send Option Value");
					setshowSuccessMessage(true);
					setTimeout(() => {

						setshowSuccessMessage(false);
						setErrormessage("");
					}, 2000);
				})



		} catch (error) {
			console.log("error fetching get api", error);
			setLoader(false)
			SetSendOptionAlert(false);
			setErrormessage("Fail TO Update Telegram Value");
			setshowSuccessMessage(true);
			setTimeout(() => {

				setshowSuccessMessage(false);
				setErrormessage("");
			}, 2000);
		}







	};


	//  open dialog box for confirmation to change telegram change
	const handletelegramConfirmation = (event) => {
		event.preventDefault();
		console.log("event.target.checked", event.target.value);
		setTelegram(event.target.value);
		SetTelegramAlert(true);
	}

	//  open dialog box for confirmation to change telegram change
	const handleSensextelegramConfirmation = (event) => {
		event.preventDefault();
		console.log("event.target.checked", event.target.value);
		setSensexTelegram(event.target.value);
		SetSensexTelegramAlert(true);
	}
	//  open dialog box for confirmation to change telegram change
	const handlesendOptionConfirmation = (event) => {
		event.preventDefault();
		console.log("event.target.checked", event.target.checked);
		setSOption(event.target.checked);
		SetSendOptionAlert(true);
	}


	// handle change to close the dialog
	const handleCloseDialog = () => {
		setshowDialog(false);
		setRenkoDialogData((prev) => ({
			...prev,
			Symbols: Symbols,
			RenkoInterval: RenkoInterval,
			BrickSize: BrickSize,
			BuySellBox: BuySellBox,
			ExitBox: ExitBox,
			range_mode: range_mode,
		}))
	}



	return (
		<>
			<Sidebar />
			<h1 className="RenkoChart_Heading">Automation Mode</h1>

			<div className="RenkoChart_Group"
			// style={{ display: 'flex', marginTop: '100px', gap: '20px' }}
			>






				<div className="RenkoChart_Container">


					<div className="Renko_Decission_Container">

						<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',marginRight:"25px" ,backgroundColor:"#9c98db",paddingRight:'10px',borderRadius:'10px'}}>
							<label style={{ width: '100%', marginTop: '10px', marginLeft:"10px" }} htmlFor="intraDay">SenSex TG Channel</label>
							{console.log("sensex telgramlive_local", Sensex_telgramlive_local)}
							
						<select value={Sensex_telgramlive_local} onChange={handleSensextelegramConfirmation} className="form-select">
						<option value="LIVE">Live</option>
						<option value="OFFS">Off</option>
                       </select>
						</div>
					    
						<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
							<label style={{ width: '100%', marginTop: '10px' }} htmlFor="intraDay">Send Option</label>
							{console.log("send option", sendOption)}
							<IOSSwitch
								sx={{ m: 1 }}
								defaultChecked
								checked={sendOption}
								onChange={handlesendOptionConfirmation}
								inputProps={{ "aria-label": "controlled" }}
							/>
						</div>
						<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
							<label style={{ width: '100%', marginTop: '10px',marginLeft:"10px" }} htmlFor="intraDay">Telegram Channel</label>
							{console.log("telgramlive_local", telgramlive_local)}
							{/* <IOSSwitch
								sx={{ m: 1 }}
								defaultChecked
								checked={telgramlive_local}
								onChange={handletelegramConfirmation}
								inputProps={{ "aria-label": "controlled" }}
							/> */}


							  {/* <InputLabel id="telegram-dropdown-label">Status</InputLabel> */}
       <select value={telgramlive_local} onChange={handletelegramConfirmation} className="form-select">
      <option value="LIVE">Live</option>
      <option value="LOCAL">Local</option>
      <option value="OFFS">Off</option>
    </select>
						</div>

						
						<div className="Renko_Decission_group">


							<div className="Renko_Decission_header">Last 3 intervals</div>
							{RenkoIntervalDecission?.[0] && (
								<>
									<div className="Renko_Decission_content" style={{ color: handleDecissionColor(RenkoIntervalDecission[0].prv_prv_interval), border: `1px solid ${handleDecissionColor(RenkoIntervalDecission[0].prv_prv_interval)}` }}>
										{RenkoIntervalDecission[0].prv_prv_interval}
									</div>
									<div className="Renko_Decission_content" style={{ color: handleDecissionColor(RenkoIntervalDecission[0].prv_interval), border: `1px solid ${handleDecissionColor(RenkoIntervalDecission[0].prv_interval)}` }}>
										{RenkoIntervalDecission[0].prv_interval}
									</div>
									<div className="Renko_Decission_content" style={{ color: handleDecissionColor(RenkoIntervalDecission[0].present_interval), border: `1px solid ${handleDecissionColor(RenkoIntervalDecission[0].present_interval)}` }}>
										{RenkoIntervalDecission[0].present_interval}
									</div>
								</>
							)}
							<div className="Renko_Decission_header">{lastupdatedtime}</div>

						</div>


					</div>


					<div className="ReckoChart_Container">
						{data.length > 0 ? (
							<div>
								{loader && (
									<div className="Renko_Loader">
										<Loading />
									</div>
								)}
								{/* <Automation
									data={data}
									BrickSize={BrickSize}
									reversalType={reversalType}
									Symbols={Symbols}
									width={(window.innerWidth) - 350} // Sets width dynamically
									sourcePath={sourcePath}
									ratio={1.0}
									type="svg"
								/> */}

								<ViewRenkoChart
									data={data}
									BrickSize={BrickSize}
									reversalType={range_mode}
									Symbols={Symbols}
									width={(window.innerWidth) - (window.innerWidth > 720 ? "350" : "")}
									sourcePath={sourcePath}
									ratio={1.0}
									type="svg"
								/>

							</div>
						) : (
							<div className="Renko_Loader">{loader && <Loading />}</div>
						)}
					</div>
				</div>


				{/* Main renko data right  */}
				<div className="Renko_Option_Container">


					<div className="Renko_Option_group">

						<div className="ChartCurrent_Container">
							<div className="ChartCurrent_group">


								<div style={{ display: 'flex' }}>
									<div className="ChartCurrent_Box">{Symbols}</div>
									<div className="ChartCurrent_Price" >{lastbrick.close}</div>
								</div>
							</div>



							<div className="ChartCurrent_Refrersh" onClick={() => {
								fetchShowAll()
								setRotation(rotation + 360);
							}}
								style={{
									transform: `rotate(${rotation}deg)`,
									transition: "transform 1s ease-in-out",
									cursor: "pointer"
								}}
							>
								<RefreshIcon style={{ color: 'white' }} />
							</div>

						</div>
					</div>


					{/* Symbol  */}
					<div className="Renko_Option_group">
						<label>Symbol</label>
						<div className="Renko_Option_group_Box" onClick={() => setshowDialog(true)}>{Symbols}</div>

					</div>

					{/* interval  */}
					<div className="Renko_Option_group">
						<label>Interval</label>
						<div className="Renko_Option_group_Box" onClick={() => setshowDialog(true)}>{RenkoInterval}</div>


					</div>

					{/* Range mode  */}
					<div className="Renko_Option_group">
						<label>Range Mode</label>
						<div className="Renko_Option_group_Box" onClick={() => setshowDialog(true)}>{range_mode}</div>

					</div>

					{/* Brick size  */}
					<div className="Renko_Option_group">
						<label>Brick size</label>
						<div className="Renko_Option_group_Box" onClick={() => setshowDialog(true)}>{BrickSize}</div>


					</div>

					{/* ATR  */}
					{range_mode === "atr" &&
						<div className="Renko_Option_group">
							<label>ATR</label>
							<div className="Renko_Option_group_Box"
								readOnly
								style={{
									backgroundColor: '#f0f0f0',
									color: '#727D73',
									cursor: 'not-allowed'
								}}>{atrData}</div>


						</div>}

					{/* Buy Sell Box  */}
					<div className="Renko_Option_group">
						<label>Buy/Sell Box</label>
						<div className="Renko_Option_group_Box" onClick={() => setshowDialog(true)}>{BuySellBox}</div>


					</div>

					{/* Exit Box  */}
					<div className="Renko_Option_group">
						<label>Exit Box</label>
						<div className="Renko_Option_group_Box" onClick={() => setshowDialog(true)}>{ExitBox}</div>

					</div>






					<div className="Renko_Option_group">
						<button className="Renko_Option_button"
							onClick={() => {
								const data = ALLRenkoData.filter((item) => item.name === RenkoDialogData.Symbols);
								setshowDialog(true);
							}}>Edit</button>
					</div>






				</div>



				{/* success message  */}

				<Modal
					show={showSuccessMessage}
					onHide={() => setshowSuccessMessage(false)}
					style={{ padding: 0, zIndex: 1500 }}

				>
					{" "}
					<Alert variant="success">
						{Errormessage}
					</Alert>
				</Modal>


			</div>




			{/* show atr pop up */}
			<Modal
				show={showatrDialog}
				onHide={() => setshowatrDialog(false)}
				style={{ zIndex: 1500 }}
			>
				<Alert variant="danger">
					You have selected ATR
				</Alert>
			</Modal>


			{/* Edit Dialog box  */}


			<Dialog
				open={showDialog}
				onClose={() => { setshowDialog(false) }}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle style={{ color: "#2380DE" }} id="alert-dialog-title">
					{"Renko Details Update"}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">


						<div className="Dialog_Option_Container">

							{/* Symbol  */}
							<div className="Dialog_Option_group">
								<label>Symbol</label>
								<select
									value={RenkoDialogData.Symbols}
									onChange={(e) => {
										// setSymbols(e.target.value);
										setRenkoDialogData((prev) => ({
											...prev,
											Symbols: e.target.value
										}))
										const data = ALLRenkoData.filter((item) => item.name === e.target.value);
										setRenkoDialogData({
											Symbols: data[0].name,
											RenkoInterval: data[0].interval,
											BrickSize: data[0].range_mode === "atr" ? data[0].atr_brick : data[0].brick_size,
											BuySellBox: data[0].buy_sell_box,
											ExitBox: data[0].ExitBox,
											groups: data[0].groups !== 'LOCAL',
											range_mode: data[0].range_mode,
										});
										setatrData(data ? data[0].atr === null ? 0 : data[0].atr : 0)
										// updateLocalStorage("Symbols", e.target.value);
									}}
								>
									<option value="NIFTY">Nifty</option>
									<option value="BANKNIFTY">Banknifty</option>
									<option value="NIFTY_MID_SELECT">Midcap</option>
									<option value="FINNIFTY">Finnifty</option>
								</select>
							</div>

							{/* interval  */}
							<div className="Dialog_Option_group">
								<label>Interval</label>
								<select
									value={RenkoDialogData.RenkoInterval}
									onChange={(e) => {
										// setRenkoInterval(e.target.value);
										setRenkoDialogData((prev) => ({
											...prev,
											RenkoInterval: e.target.value
										}))
										// updateLocalStorage("RenkoInterval", e.target.value);
									}}
								>
									<option value="5">5 minutes</option>
									<option value="10">10 minutes</option>
									<option value="15">15 minutes</option>
									<option value="25">25 minutes</option>
									<option value="30">30 minutes</option>
									<option value="35">35 minutes</option>
									<option value="45">45 minutes</option>
									<option value="60">60 minutes</option>
									<option value="120">120 minutes</option>
									<option value="125">125 minutes</option>
									<option value="375">1 Day</option>
								</select>
							</div>

							{/* Range mode  */}
							<div className="Dialog_Option_group">
								<label>Range Mode</label>
								<select
									value={RenkoDialogData.range_mode}
									onChange={(e) => {
										const data = ALLRenkoData.filter((item) => item.name === RenkoDialogData.Symbols);

										// setReversalType(e.target.value);
										setRenkoDialogData((prev) => ({
											...prev,
											range_mode: e.target.value,
											BrickSize: e.target.value === "atr" ? data[0].atr_brick : data[0].brick_size,

										}))
										// updateLocalStorage("reversalType", e.target.value);
									}}


								>
									<option value="atr">Average True Range</option>
									<option value="fixed">Fixed</option>
								</select>
							</div>

							{/* Brick Size  */}
							<div className="Dialog_Option_group">
								<label>Brick size</label>

								<input
									type="text"
									value={RenkoDialogData.BrickSize}
									onKeyPress={(e) => handleNumber(e)}
									readOnly={RenkoDialogData.range_mode === "atr"}
									style={RenkoDialogData.range_mode === "atr" ? {
										backgroundColor: '#f0f0f0',
										color: '#727D73',
										cursor: 'not-allowed'
									} : {}}
									onClick={() => {
										if (RenkoDialogData.range_mode === "atr") {
											setshowatrDialog(true);
											console.log("Open the dialog");

											// alert("You have selected ATR")
											setTimeout(() => {
												setshowatrDialog(false);

											}, 500);
										}
									}}
									onChange={(e) => {
										if (RenkoDialogData.range_mode === "atr") {
											return; // Prevent any changes when ATR is selected
										}

										if (e.target.value >= 500) {
											e.preventDefault();
										}
										else {
											// setBrickSize(e.target.value);
											setRenkoDialogData((prev) => ({
												...prev,
												BrickSize: e.target.value
											}))
											// updateLocalStorage("BrickSize", e.target.value);
										}
									}}
								/>
							</div>

							{/* Buy Sell Box  */}
							<div className="Dialog_Option_group">
								<label>Buy/Sell Box</label>

								<input
									type="number"
									value={RenkoDialogData.BuySellBox}
									onKeyPress={(e) => handleNumber(e)}
									onChange={(e) => {

										if (e.target.value >= 101) {
											e.preventDefault();
										}
										else {
											setRenkoDialogData((prev) => ({
												...prev,
												BuySellBox: e.target.value
											}))
										}
									}}
								/>
							</div>

							{/* Exit Box  */}
							<div className="Dialog_Option_group">
								<label>Exit Box</label>

								<input
									type="number"
									value={RenkoDialogData.ExitBox}
									onKeyPress={(e) => handleNumber(e)}
									onChange={(e) => {

										if (e.target.value >= 101) {
											e.preventDefault();
										}
										else {
											setRenkoDialogData((prev) => ({
												...prev,
												ExitBox: e.target.value
											}))
										}
									}}
								/>
							</div>

							{/* Reason for changes  */}
							<div className="Dialog_Option_group">
								<div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>

									<label style={{ display: 'flex', width: '100%' }}>Reason for Change <span style={{ color: '#C1BAA1', marginLeft: '5px', display: 'flex' }}>{Remarks.length}/250</span></label>
									<textarea value={Remarks} rows="6" onChange={handleRemarks} ></textarea>
								</div>

							</div>

						</div>


					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button className="Dialog_button"
						variant="outlined"
						color="error"
						onClick={handleCloseDialog}
					>
						No
					</Button>
					<Button className="Dialog_button"
						variant="outlined"
						color="success"
						onClick={handleValueChange}
						autoFocus
					>
						Yes
					</Button>
				</DialogActions>
			</Dialog>



			{/* Telegram toggle Confirmation Dialog */}

			<Dialog
				open={TelegramAlert}
				onClose={() => SetTelegramAlert(false)}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle style={{ color: "#2380DE", width: '100%', textAlign: 'center', display: 'block' }} id="alert-dialog-title">
					{"Confirmation "}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Are you sure, you want to Change Telegram Toggle
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button className="btn-cancel"
						variant="outlined"
						color="error"
						onClick={() => SetTelegramAlert(false)}
					>
						No
					</Button>
					<Button className="btn-submit"
						variant="outlined"
						color="success"
						onClick={handletelegramLiveLocalChange}
						autoFocus
					>
						Yes
					</Button>
				</DialogActions>
			</Dialog>
			{/* Sensex Telegram toggle Confirmation Dialog */}

			<Dialog
				open={SensexTelegramAlert}
				onClose={() => SetSensexTelegramAlert(false)}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle style={{ color: "#2380DE", width: '100%', textAlign: 'center', display: 'block' }} id="alert-dialog-title">
					{"Confirmation "}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Are you sure, you want to Change Telegram Toggle For SenSex
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button className="btn-cancel"
						variant="outlined"
						color="error"
						onClick={() => SetSensexTelegramAlert(false)}
					>
						No
					</Button>
					<Button className="btn-submit"
						variant="outlined"
						color="success"
						onClick={handleSensextelegramLiveLocalChange}
						autoFocus
					>
						Yes
					</Button>
				</DialogActions>
			</Dialog>

			{/* send Option Change confirmation */}
			<Dialog
				open={sendOptionAlert}
				onClose={() => SetSendOptionAlert(false)}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle style={{ color: "#2380DE", width: '100%', textAlign: 'center', display: 'block' }} id="alert-dialog-title">
					{"Confirmation "}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Are you sure, you want to Change Send Option Toggle
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button className="btn-cancel"
						variant="outlined"
						color="error"
						onClick={() => SetSendOptionAlert(false)}
					>
						No
					</Button>
					<Button className="btn-submit"
						variant="outlined"
						color="success"
						onClick={handleSendOptionChange}
						autoFocus
					>
						Yes
					</Button>
				</DialogActions>
			</Dialog>


			{/* Dialog box to show error message */}

			   {/*Error Message Dialog */}
					  <Dialog
				  open={errorDialog}
				  onClose={()=>{setErrorDialog(false)}}
				  aria-labelledby="alert-dialog-title"
				  aria-describedby="alert-dialog-description"
				>
				  <DialogTitle  id="alert-dialog-title">
				  <h4 style={{ color: "red" }}>Failure</h4>
				  </DialogTitle>
				  <DialogContent>
					<DialogContentText id="alert-dialog-description">
					 
						   
					  {errorMessage}
					   
					
					</DialogContentText>
				  </DialogContent>
				 
					  </Dialog>

		</>

	);
}





export default AutomateReknko

